/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelMovementOrderLookup.ts           *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/movement-order-lookup";

export class AutogenModelMovementOrderLookup<RowType extends ModelRow> extends Endpoint<RowType, RowMovementOrderLookupFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowMovementOrderLookup extends ModelRow<RowMovementOrderLookupFields> {
	constructor(values?: Partial<RowMovementOrderLookupFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowMovementOrderLookupFields {
	company_id: string;
	"dest.actual_arrival": Date;
	"dest.actual_departure": Date;
	"dest.address": string;
	"dest.address2": string;
	"dest.appointment_status_id": string;
	"dest.appt_contact_name": string;
	"dest.appt_required": string;
	"dest.cases": number;
	"dest.city_id": number;
	"dest.city_name": string;
	"dest.company_id": string;
	"dest.confirmed": string;
	"dest.contact_email": string;
	"dest.contact_name": string;
	"dest.dist_from_prev": number;
	"dest.dist_from_prev_um": string;
	"dest.driver_load_unload": string;
	"dest.edi_code": string;
	"dest.edi_loc_code": string;
	"dest.eta": Date;
	"dest.eta_distance": number;
	"dest.eta_late": string;
	"dest.eta_oor": string;
	"dest.google_place_id": string;
	"dest.grouped_id": number;
	"dest.hub": number;
	"dest.ic_stop_id": string;
	"dest.id": string;
	"dest.inbound_status": string;
	"dest.late_eta_colorcode": string;
	"dest.late_route_status": string;
	"dest.latitude": number;
	"dest.location_id": string;
	"dest.location_name": string;
	"dest.longitude": number;
	"dest.manifest_fgp_uid": number;
	"dest.manifest_reg_uid": number;
	"dest.move_dist_from_preassign": number;
	"dest.move_dist_from_preassign_um": string;
	"dest.move_dist_from_previous": number;
	"dest.move_dist_from_previous_um": string;
	"dest.movement_id": string;
	"dest.movement_sequence": number;
	"dest.operational_status": string;
	"dest.order_id": string;
	"dest.order_sequence": number;
	"dest.orig_sched_early": Date;
	"dest.orig_sched_late": Date;
	"dest.pallets_dropped": number;
	"dest.pallets_picked_up": number;
	"dest.payment_code_reviewed": string;
	"dest.phone": string;
	"dest.planned_arrival_time": Date;
	"dest.ponum": string;
	"dest.prior_uncleared_stops": string;
	"dest.projected_arrival": Date;
	"dest.pu_override_arrive_early": Date;
	"dest.pu_override_arrive_late": Date;
	"dest.rate_dist_from_previous": number;
	"dest.rate_dist_from_previous_um": string;
	"dest.refno": string;
	"dest.requested_service": string;
	"dest.sched_arrive_early": Date;
	"dest.sched_arrive_late": Date;
	"dest.seal": string;
	"dest.service_date": Date;
	"dest.showas_address": string;
	"dest.showas_address2": string;
	"dest.showas_city_id": number;
	"dest.showas_city_name": string;
	"dest.showas_location_id": string;
	"dest.showas_location_name": string;
	"dest.showas_state": string;
	"dest.showas_zip_code": string;
	"dest.signed_for_name": string;
	"dest.state": string;
	"dest.status": string;
	"dest.stop_type": string;
	"dest.trimble_place_id": string;
	"dest.txl_uid": number;
	"dest.volume": number;
	"dest.volume_um": string;
	"dest.weight": number;
	"dest.weight_um": string;
	"dest.zip_code": string;
	"dest.zone_id": string;
	"dispatcher_users.acct_lock_date": Date;
	"dispatcher_users.active_date": Date;
	"dispatcher_users.admin_user": string;
	"dispatcher_users.agent": string;
	"dispatcher_users.agree_fieldmarshal": Date;
	"dispatcher_users.agree_tailor": Date;
	"dispatcher_users.agree_tailor_ext": Date;
	"dispatcher_users.all_contacts": string;
	"dispatcher_users.allow_new_devices": string;
	"dispatcher_users.alternative_user": string;
	"dispatcher_users.ap_division_id": string;
	"dispatcher_users.appt_sched_id": string;
	"dispatcher_users.auth_subject": string;
	"dispatcher_users.auto_edit_type": string;
	"dispatcher_users.avail_tract_path": string;
	"dispatcher_users.avail_tract_sample": string;
	"dispatcher_users.available": string;
	"dispatcher_users.bridge_customer_access": string;
	"dispatcher_users.brokerage_divider": number;
	"dispatcher_users.brokerage_planning": string;
	"dispatcher_users.brokerage_planning2": string;
	"dispatcher_users.brokerage_planning3": string;
	"dispatcher_users.brokerage_planning4": string;
	"dispatcher_users.brokerage_planning_contnr": string;
	"dispatcher_users.call_list_profile": string;
	"dispatcher_users.carrier_call_list_id": string;
	"dispatcher_users.carrier_mgr_profil": string;
	"dispatcher_users.carrier_mgr_profil2": string;
	"dispatcher_users.carrier_mgr_profil3": string;
	"dispatcher_users.carrier_mgr_profil4": string;
	"dispatcher_users.cell_phone": string;
	"dispatcher_users.close_window": string;
	"dispatcher_users.commission_payee_id": string;
	"dispatcher_users.company_id": string;
	"dispatcher_users.company_name": string;
	"dispatcher_users.conf_cntr_template": number;
	"dispatcher_users.conf_template": number;
	"dispatcher_users.confirm_record": string;
	"dispatcher_users.contact_id": string;
	"dispatcher_users.continuous_radius": number;
	"dispatcher_users.crm_vs_profile": string;
	"dispatcher_users.csm_profile_id": string;
	"dispatcher_users.csm_profile_id2": string;
	"dispatcher_users.csm_profile_id3": string;
	"dispatcher_users.csm_profile_id4": string;
	"dispatcher_users.currency_reporting": string;
	"dispatcher_users.currency_transaction": string;
	"dispatcher_users.daily_advance_limits": string;
	"dispatcher_users.daily_brok_profile": string;
	"dispatcher_users.daily_snap_profile": string;
	"dispatcher_users.date_format": string;
	"dispatcher_users.default_search": number;
	"dispatcher_users.default_wirecode": string;
	"dispatcher_users.delivered_load_day": number;
	"dispatcher_users.department_id": string;
	"dispatcher_users.detention_profile_id": string;
	"dispatcher_users.detention_profile_id2": string;
	"dispatcher_users.detention_profile_id3": string;
	"dispatcher_users.detention_profile_id4": string;
	"dispatcher_users.disp_new_order_screen": string;
	"dispatcher_users.distance_calc_vendor": string;
	"dispatcher_users.dock_enable_wfmd_mode_swtch": string;
	"dispatcher_users.dock_login_id": string;
	"dispatcher_users.dragndrop_profile_id": string;
	"dispatcher_users.driver_manager_profile": string;
	"dispatcher_users.driver_manager_profile2": string;
	"dispatcher_users.driver_manager_profile3": string;
	"dispatcher_users.driver_manager_profile4": string;
	"dispatcher_users.driver_manager_vendor": string;
	"dispatcher_users.driver_managers": string;
	"dispatcher_users.drivers_wo_manager": string;
	"dispatcher_users.ds_cap_profile": string;
	"dispatcher_users.ds_mv_eta_profile": string;
	"dispatcher_users.ds_mv_eval_profile": string;
	"dispatcher_users.dsp_override_user": string;
	"dispatcher_users.email_address": string;
	"dispatcher_users.email_bcc": string;
	"dispatcher_users.email_client": string;
	"dispatcher_users.email_host": string;
	"dispatcher_users.email_imap_host": string;
	"dispatcher_users.email_imap_password": string;
	"dispatcher_users.email_imap_sent_folder": string;
	"dispatcher_users.email_imap_ssl": string;
	"dispatcher_users.email_imap_username": string;
	"dispatcher_users.email_override_company": string;
	"dispatcher_users.email_password": string;
	"dispatcher_users.email_port": number;
	"dispatcher_users.email_protocol": string;
	"dispatcher_users.email_use_sent_folder": string;
	"dispatcher_users.email_username": string;
	"dispatcher_users.employee_type": string;
	"dispatcher_users.enable_alerts": string;
	"dispatcher_users.extension": string;
	"dispatcher_users.external_password": string;
	"dispatcher_users.external_user_id": string;
	"dispatcher_users.failed_logins": number;
	"dispatcher_users.fax": string;
	"dispatcher_users.fileimport_profile": string;
	"dispatcher_users.findnear_vendor": string;
	"dispatcher_users.fleetmgmt_prof_id": string;
	"dispatcher_users.fm_account_id": string;
	"dispatcher_users.fm_can_view_metadata": string;
	"dispatcher_users.fm_profile_id": string;
	"dispatcher_users.fm_webhook_url": string;
	"dispatcher_users.ftl_revenue_code_id": string;
	"dispatcher_users.google_map_layer": string;
	"dispatcher_users.google_map_type": string;
	"dispatcher_users.grid_even_row_color": number;
	"dispatcher_users.grid_insert_sort": string;
	"dispatcher_users.grid_odd_row_color": number;
	"dispatcher_users.id": string;
	"dispatcher_users.img_category": string;
	"dispatcher_users.inactive_date": Date;
	"dispatcher_users.is_active": string;
	"dispatcher_users.is_clearer": string;
	"dispatcher_users.is_closer": string;
	"dispatcher_users.is_dock_supervisor": string;
	"dispatcher_users.is_dock_worker": string;
	"dispatcher_users.is_email_confirmed": string;
	"dispatcher_users.is_mcleod": string;
	"dispatcher_users.issue_atm_cash": string;
	"dispatcher_users.lock_status": string;
	"dispatcher_users.log_sql": string;
	"dispatcher_users.login_id": string;
	"dispatcher_users.ltl_carrier_brk_status": string;
	"dispatcher_users.ltl_mapping_vendor": string;
	"dispatcher_users.ltl_quote_template": number;
	"dispatcher_users.manifest_profile": string;
	"dispatcher_users.margin_percentage": number;
	"dispatcher_users.max_payment_code_amt": number;
	"dispatcher_users.max_payment_code_amt_c": string;
	"dispatcher_users.max_payment_code_amt_d": Date;
	"dispatcher_users.max_payment_code_amt_n": number;
	"dispatcher_users.max_payment_code_amt_r": number;
	"dispatcher_users.mc_position_vendor": string;
	"dispatcher_users.menu_tree_view": string;
	"dispatcher_users.mfa_device_id": string;
	"dispatcher_users.mfa_last_prompted": Date;
	"dispatcher_users.mfa_secret": string;
	"dispatcher_users.mfa_status": string;
	"dispatcher_users.mobcomm_profile_id": string;
	"dispatcher_users.mobile_pw_reset_token": string;
	"dispatcher_users.mobile_pw_token_expire_ms": number;
	"dispatcher_users.move_dates": string;
	"dispatcher_users.movement_map_vendor": string;
	"dispatcher_users.name": string;
	"dispatcher_users.notification": string;
	"dispatcher_users.notify_alerts": string;
	"dispatcher_users.notify_frequency": string;
	"dispatcher_users.notify_method": string;
	"dispatcher_users.notify_occurance": string;
	"dispatcher_users.operations_user_id": string;
	"dispatcher_users.order_mode": string;
	"dispatcher_users.order_planning2": string;
	"dispatcher_users.order_planning3": string;
	"dispatcher_users.order_planning4": string;
	"dispatcher_users.order_planning_vendor": string;
	"dispatcher_users.order_tran_request": string;
	"dispatcher_users.orderhist_profile": string;
	"dispatcher_users.outbound_notification": string;
	"dispatcher_users.override_vendor_division": string;
	"dispatcher_users.payee_id": string;
	"dispatcher_users.pbw_brokerage_planning": string;
	"dispatcher_users.phone": string;
	"dispatcher_users.planner": string;
	"dispatcher_users.planning": string;
	"dispatcher_users.planning_container": string;
	"dispatcher_users.planning_divider": number;
	"dispatcher_users.portal_admin_id": string;
	"dispatcher_users.primary_agency": string;
	"dispatcher_users.prompt_cont_moves": string;
	"dispatcher_users.quote_comp_act_create": string;
	"dispatcher_users.quote_comp_act_id": string;
	"dispatcher_users.quote_pend_act_create": string;
	"dispatcher_users.quote_pend_act_id": string;
	"dispatcher_users.quote_template": number;
	"dispatcher_users.rapid_alert_expand": string;
	"dispatcher_users.rapid_alert_sound": string;
	"dispatcher_users.receive_alerts": string;
	"dispatcher_users.recruiting_profile": string;
	"dispatcher_users.request_location_vendor": string;
	"dispatcher_users.revenue_code_id": string;
	"dispatcher_users.route_detail_vendor": string;
	"dispatcher_users.save_screen_sizes": string;
	"dispatcher_users.search_history_limit": number;
	"dispatcher_users.sec_ans1": string;
	"dispatcher_users.sec_ans2": string;
	"dispatcher_users.sec_question1": number;
	"dispatcher_users.sec_question2": number;
	"dispatcher_users.seg_alloc_code": string;
	"dispatcher_users.sel_text_on_focus": string;
	"dispatcher_users.show_active": string;
	"dispatcher_users.show_google_route": string;
	"dispatcher_users.show_inactive": string;
	"dispatcher_users.single_point_vendor": string;
	"dispatcher_users.support_inactivate_date": Date;
	"dispatcher_users.system_tray": string;
	"dispatcher_users.table_even_row_color": string;
	"dispatcher_users.table_odd_row_color": string;
	"dispatcher_users.telephony_access_token": string;
	"dispatcher_users.telephony_access_token_exp": Date;
	"dispatcher_users.telephony_number": string;
	"dispatcher_users.telephony_password": string;
	"dispatcher_users.telephony_refresh_token": string;
	"dispatcher_users.telephony_refresh_token_exp": Date;
	"dispatcher_users.terminal_id": string;
	"dispatcher_users.time_format": string;
	"dispatcher_users.token_key": number;
	"dispatcher_users.toolbar_multi_rows": string;
	"dispatcher_users.toolbar_setting": string;
	"dispatcher_users.trailer_loan_profile_id": string;
	"dispatcher_users.trailer_wash_loc": string;
	"dispatcher_users.trailer_wash_user": string;
	"dispatcher_users.trimble_map_traffic": string;
	"dispatcher_users.tw_seg_code": string;
	"dispatcher_users.tw_ticket_template": number;
	"dispatcher_users.type_agents": string;
	"dispatcher_users.type_carrier": string;
	"dispatcher_users.type_company_drs": string;
	"dispatcher_users.type_number": string;
	"dispatcher_users.type_owner_oper": string;
	"dispatcher_users.user_group": string;
	"dispatcher_users.vendor_user_id": string;
	"dispatcher_users.view_movement_vendor": string;
	"dispatcher_users.waterfall_default_rt_guide": string;
	"dispatcher_users.waterfall_include_rates": string;
	"dispatcher_users.waterfall_include_rt_guides": string;
	"dispatcher_users.waterfall_prevent_tendering": string;
	"dispatcher_users.web_acct_status": string;
	"dispatcher_users.web_agent": string;
	"dispatcher_users.web_created_on": Date;
	"dispatcher_users.web_enabled_on": Date;
	"dispatcher_users.web_last_login": Date;
	"dispatcher_users.web_locked_on": Date;
	"dispatcher_users.web_map": string;
	"dispatcher_users.web_password": string;
	"dispatcher_users.web_user_id": string;
	"dispatcher_users.web_user_type": string;
	"dispatcher_users.window_location": string;
	"dispatcher_users.windows_login": string;
	"dispatcher_users.wire_trans_per_day": number;
	"dispatcher_users.zone_mapping_vendor": string;
	"driver.ace_id": string;
	"driver.address": string;
	"driver.alert": string;
	"driver.allow_trailer_drop": string;
	"driver.avl_as_of_date": Date;
	"driver.avl_drive_hours": number;
	"driver.avl_hours": number;
	"driver.avl_onduty_hours": number;
	"driver.base_term1": string;
	"driver.base_term2": string;
	"driver.base_zip1": string;
	"driver.base_zip2": string;
	"driver.birth_date": Date;
	"driver.bseg": string;
	"driver.can_rehire": string;
	"driver.capcreat_filter": string;
	"driver.cb": string;
	"driver.cell_phone": string;
	"driver.chain_pref_1": string;
	"driver.chain_pref_1_value": number;
	"driver.chain_pref_2": string;
	"driver.chain_pref_2_value": number;
	"driver.choice_allocation": string;
	"driver.choice_commodity": string;
	"driver.choice_commodity_exclude": string;
	"driver.choice_customer": string;
	"driver.choice_equip_type": string;
	"driver.choice_exclude_hazmat": string;
	"driver.choice_order_type": string;
	"driver.choice_priority1": string;
	"driver.choice_priority1_value": number;
	"driver.choice_priority2": string;
	"driver.choice_priority2_value": number;
	"driver.choice_revenue": string;
	"driver.choice_review_dt": Date;
	"driver.citizen": string;
	"driver.citizen_country": string;
	"driver.city": string;
	"driver.city_id": number;
	"driver.cmove": string;
	"driver.company_id": string;
	"driver.country_hos_rules": string;
	"driver.country_id": string;
	"driver.currenteqpgrpid": string;
	"driver.ded_rqmt_type": string;
	"driver.ded_type": string;
	"driver.disable_driver_choice": string;
	"driver.disable_feasibility": string;
	"driver.disable_remote_access": string;
	"driver.doubles_certified": string;
	"driver.dri_uid": number;
	"driver.drvr_class": string;
	"driver.ds_model_flag": string;
	"driver.eld_exempt_reason_id": string;
	"driver.email": string;
	"driver.emrg_response_date": Date;
	"driver.enable_driver_app": string;
	"driver.enable_load_choice": string;
	"driver.end_status_date": Date;
	"driver.enginedata_pwd": string;
	"driver.equipment_type_id": string;
	"driver.event_date": Date;
	"driver.event_status": string;
	"driver.exclude_allocation": string;
	"driver.exclude_commodity": string;
	"driver.exclude_customer": string;
	"driver.exclude_equip_type": string;
	"driver.exclude_feasibility": string;
	"driver.exclude_order_type": string;
	"driver.exclude_revenue": string;
	"driver.experience": string;
	"driver.first_name": string;
	"driver.fleet_manager": string;
	"driver.fmcsa_clearinghouse_date": Date;
	"driver.group_id": string;
	"driver.hazmat_certified": string;
	"driver.hazmat_date": Date;
	"driver.hire_date": Date;
	"driver.hm126c_date": Date;
	"driver.home_duration": number;
	"driver.home_location_id": string;
	"driver.id": string;
	"driver.is_active": string;
	"driver.last_34_hour_start_date": Date;
	"driver.last_break_date": Date;
	"driver.last_home_date": Date;
	"driver.last_review_date": Date;
	"driver.latitude": number;
	"driver.license_country": string;
	"driver.license_date": Date;
	"driver.license_no": string;
	"driver.license_state": string;
	"driver.logbook_required": string;
	"driver.longitude": number;
	"driver.manual_pta_update": string;
	"driver.maryland_perm_date": Date;
	"driver.max_dispatches": number;
	"driver.max_dist_loc1": number;
	"driver.max_dist_loc2": number;
	"driver.max_mi_per_day": number;
	"driver.mc_login": string;
	"driver.mc_unit_password": string;
	"driver.medical_cert_exempt": string;
	"driver.medical_cert_expire": Date;
	"driver.model_flag": string;
	"driver.mpw_driver_contact_method": string;
	"driver.mpw_driver_high": number;
	"driver.mpw_driver_low": number;
	"driver.mpw_exclude": string;
	"driver.mpw_last_contact": Date;
	"driver.mpw_num_attempts": number;
	"driver.mpw_num_orders": number;
	"driver.mvr_date": Date;
	"driver.name": string;
	"driver.name_mid_initial": string;
	"driver.name_of_spouse": string;
	"driver.next_home_date": Date;
	"driver.num_complaints": number;
	"driver.pager": string;
	"driver.passport": string;
	"driver.payee_id": string;
	"driver.personal_conveyance": string;
	"driver.phone": string;
	"driver.physical_date": Date;
	"driver.planning_comment": string;
	"driver.preferred_days_out": number;
	"driver.prev_code": string;
	"driver.primary_agency": string;
	"driver.proximity_card": string;
	"driver.pta_date": Date;
	"driver.race": string;
	"driver.reason_for_leaving": string;
	"driver.record_pta": string;
	"driver.remark": string;
	"driver.reporting_status": string;
	"driver.return_home_flag": string;
	"driver.route_through_term": string;
	"driver.safety_meet_date": Date;
	"driver.safety_topic": string;
	"driver.security_date": Date;
	"driver.sex": string;
	"driver.shuttle_capable": string;
	"driver.site_id": string;
	"driver.social_security_no": string;
	"driver.speed": number;
	"driver.start_status_date": Date;
	"driver.state": string;
	"driver.status_code": string;
	"driver.stop_pta_update": string;
	"driver.tanks_endorsement": string;
	"driver.team_status": string;
	"driver.tenstreet_id": string;
	"driver.termination_date": Date;
	"driver.tractor_id": string;
	"driver.trainee": string;
	"driver.type_of": string;
	"driver.violation_comment": string;
	"driver.yard_move": string;
	"driver.zip": string;
	"driver_manager_users.acct_lock_date": Date;
	"driver_manager_users.active_date": Date;
	"driver_manager_users.admin_user": string;
	"driver_manager_users.agent": string;
	"driver_manager_users.agree_fieldmarshal": Date;
	"driver_manager_users.agree_tailor": Date;
	"driver_manager_users.agree_tailor_ext": Date;
	"driver_manager_users.all_contacts": string;
	"driver_manager_users.allow_new_devices": string;
	"driver_manager_users.alternative_user": string;
	"driver_manager_users.ap_division_id": string;
	"driver_manager_users.appt_sched_id": string;
	"driver_manager_users.auth_subject": string;
	"driver_manager_users.auto_edit_type": string;
	"driver_manager_users.avail_tract_path": string;
	"driver_manager_users.avail_tract_sample": string;
	"driver_manager_users.available": string;
	"driver_manager_users.bridge_customer_access": string;
	"driver_manager_users.brokerage_divider": number;
	"driver_manager_users.brokerage_planning": string;
	"driver_manager_users.brokerage_planning2": string;
	"driver_manager_users.brokerage_planning3": string;
	"driver_manager_users.brokerage_planning4": string;
	"driver_manager_users.brokerage_planning_contnr": string;
	"driver_manager_users.call_list_profile": string;
	"driver_manager_users.carrier_call_list_id": string;
	"driver_manager_users.carrier_mgr_profil": string;
	"driver_manager_users.carrier_mgr_profil2": string;
	"driver_manager_users.carrier_mgr_profil3": string;
	"driver_manager_users.carrier_mgr_profil4": string;
	"driver_manager_users.cell_phone": string;
	"driver_manager_users.close_window": string;
	"driver_manager_users.commission_payee_id": string;
	"driver_manager_users.company_id": string;
	"driver_manager_users.company_name": string;
	"driver_manager_users.conf_cntr_template": number;
	"driver_manager_users.conf_template": number;
	"driver_manager_users.confirm_record": string;
	"driver_manager_users.contact_id": string;
	"driver_manager_users.continuous_radius": number;
	"driver_manager_users.crm_vs_profile": string;
	"driver_manager_users.csm_profile_id": string;
	"driver_manager_users.csm_profile_id2": string;
	"driver_manager_users.csm_profile_id3": string;
	"driver_manager_users.csm_profile_id4": string;
	"driver_manager_users.currency_reporting": string;
	"driver_manager_users.currency_transaction": string;
	"driver_manager_users.daily_advance_limits": string;
	"driver_manager_users.daily_brok_profile": string;
	"driver_manager_users.daily_snap_profile": string;
	"driver_manager_users.date_format": string;
	"driver_manager_users.default_search": number;
	"driver_manager_users.default_wirecode": string;
	"driver_manager_users.delivered_load_day": number;
	"driver_manager_users.department_id": string;
	"driver_manager_users.detention_profile_id": string;
	"driver_manager_users.detention_profile_id2": string;
	"driver_manager_users.detention_profile_id3": string;
	"driver_manager_users.detention_profile_id4": string;
	"driver_manager_users.disp_new_order_screen": string;
	"driver_manager_users.distance_calc_vendor": string;
	"driver_manager_users.dock_enable_wfmd_mode_swtch": string;
	"driver_manager_users.dock_login_id": string;
	"driver_manager_users.dragndrop_profile_id": string;
	"driver_manager_users.driver_manager_profile": string;
	"driver_manager_users.driver_manager_profile2": string;
	"driver_manager_users.driver_manager_profile3": string;
	"driver_manager_users.driver_manager_profile4": string;
	"driver_manager_users.driver_manager_vendor": string;
	"driver_manager_users.driver_managers": string;
	"driver_manager_users.drivers_wo_manager": string;
	"driver_manager_users.ds_cap_profile": string;
	"driver_manager_users.ds_mv_eta_profile": string;
	"driver_manager_users.ds_mv_eval_profile": string;
	"driver_manager_users.dsp_override_user": string;
	"driver_manager_users.email_address": string;
	"driver_manager_users.email_bcc": string;
	"driver_manager_users.email_client": string;
	"driver_manager_users.email_host": string;
	"driver_manager_users.email_imap_host": string;
	"driver_manager_users.email_imap_password": string;
	"driver_manager_users.email_imap_sent_folder": string;
	"driver_manager_users.email_imap_ssl": string;
	"driver_manager_users.email_imap_username": string;
	"driver_manager_users.email_override_company": string;
	"driver_manager_users.email_password": string;
	"driver_manager_users.email_port": number;
	"driver_manager_users.email_protocol": string;
	"driver_manager_users.email_use_sent_folder": string;
	"driver_manager_users.email_username": string;
	"driver_manager_users.employee_type": string;
	"driver_manager_users.enable_alerts": string;
	"driver_manager_users.extension": string;
	"driver_manager_users.external_password": string;
	"driver_manager_users.external_user_id": string;
	"driver_manager_users.failed_logins": number;
	"driver_manager_users.fax": string;
	"driver_manager_users.fileimport_profile": string;
	"driver_manager_users.findnear_vendor": string;
	"driver_manager_users.fleetmgmt_prof_id": string;
	"driver_manager_users.fm_account_id": string;
	"driver_manager_users.fm_can_view_metadata": string;
	"driver_manager_users.fm_profile_id": string;
	"driver_manager_users.fm_webhook_url": string;
	"driver_manager_users.ftl_revenue_code_id": string;
	"driver_manager_users.google_map_layer": string;
	"driver_manager_users.google_map_type": string;
	"driver_manager_users.grid_even_row_color": number;
	"driver_manager_users.grid_insert_sort": string;
	"driver_manager_users.grid_odd_row_color": number;
	"driver_manager_users.id": string;
	"driver_manager_users.img_category": string;
	"driver_manager_users.inactive_date": Date;
	"driver_manager_users.is_active": string;
	"driver_manager_users.is_clearer": string;
	"driver_manager_users.is_closer": string;
	"driver_manager_users.is_dock_supervisor": string;
	"driver_manager_users.is_dock_worker": string;
	"driver_manager_users.is_email_confirmed": string;
	"driver_manager_users.is_mcleod": string;
	"driver_manager_users.issue_atm_cash": string;
	"driver_manager_users.lock_status": string;
	"driver_manager_users.log_sql": string;
	"driver_manager_users.login_id": string;
	"driver_manager_users.ltl_carrier_brk_status": string;
	"driver_manager_users.ltl_mapping_vendor": string;
	"driver_manager_users.ltl_quote_template": number;
	"driver_manager_users.manifest_profile": string;
	"driver_manager_users.margin_percentage": number;
	"driver_manager_users.max_payment_code_amt": number;
	"driver_manager_users.max_payment_code_amt_c": string;
	"driver_manager_users.max_payment_code_amt_d": Date;
	"driver_manager_users.max_payment_code_amt_n": number;
	"driver_manager_users.max_payment_code_amt_r": number;
	"driver_manager_users.mc_position_vendor": string;
	"driver_manager_users.menu_tree_view": string;
	"driver_manager_users.mfa_device_id": string;
	"driver_manager_users.mfa_last_prompted": Date;
	"driver_manager_users.mfa_secret": string;
	"driver_manager_users.mfa_status": string;
	"driver_manager_users.mobcomm_profile_id": string;
	"driver_manager_users.mobile_pw_reset_token": string;
	"driver_manager_users.mobile_pw_token_expire_ms": number;
	"driver_manager_users.move_dates": string;
	"driver_manager_users.movement_map_vendor": string;
	"driver_manager_users.name": string;
	"driver_manager_users.notification": string;
	"driver_manager_users.notify_alerts": string;
	"driver_manager_users.notify_frequency": string;
	"driver_manager_users.notify_method": string;
	"driver_manager_users.notify_occurance": string;
	"driver_manager_users.operations_user_id": string;
	"driver_manager_users.order_mode": string;
	"driver_manager_users.order_planning2": string;
	"driver_manager_users.order_planning3": string;
	"driver_manager_users.order_planning4": string;
	"driver_manager_users.order_planning_vendor": string;
	"driver_manager_users.order_tran_request": string;
	"driver_manager_users.orderhist_profile": string;
	"driver_manager_users.outbound_notification": string;
	"driver_manager_users.override_vendor_division": string;
	"driver_manager_users.payee_id": string;
	"driver_manager_users.pbw_brokerage_planning": string;
	"driver_manager_users.phone": string;
	"driver_manager_users.planner": string;
	"driver_manager_users.planning": string;
	"driver_manager_users.planning_container": string;
	"driver_manager_users.planning_divider": number;
	"driver_manager_users.portal_admin_id": string;
	"driver_manager_users.primary_agency": string;
	"driver_manager_users.prompt_cont_moves": string;
	"driver_manager_users.quote_comp_act_create": string;
	"driver_manager_users.quote_comp_act_id": string;
	"driver_manager_users.quote_pend_act_create": string;
	"driver_manager_users.quote_pend_act_id": string;
	"driver_manager_users.quote_template": number;
	"driver_manager_users.rapid_alert_expand": string;
	"driver_manager_users.rapid_alert_sound": string;
	"driver_manager_users.receive_alerts": string;
	"driver_manager_users.recruiting_profile": string;
	"driver_manager_users.request_location_vendor": string;
	"driver_manager_users.revenue_code_id": string;
	"driver_manager_users.route_detail_vendor": string;
	"driver_manager_users.save_screen_sizes": string;
	"driver_manager_users.search_history_limit": number;
	"driver_manager_users.sec_ans1": string;
	"driver_manager_users.sec_ans2": string;
	"driver_manager_users.sec_question1": number;
	"driver_manager_users.sec_question2": number;
	"driver_manager_users.seg_alloc_code": string;
	"driver_manager_users.sel_text_on_focus": string;
	"driver_manager_users.show_active": string;
	"driver_manager_users.show_google_route": string;
	"driver_manager_users.show_inactive": string;
	"driver_manager_users.single_point_vendor": string;
	"driver_manager_users.support_inactivate_date": Date;
	"driver_manager_users.system_tray": string;
	"driver_manager_users.table_even_row_color": string;
	"driver_manager_users.table_odd_row_color": string;
	"driver_manager_users.telephony_access_token": string;
	"driver_manager_users.telephony_access_token_exp": Date;
	"driver_manager_users.telephony_number": string;
	"driver_manager_users.telephony_password": string;
	"driver_manager_users.telephony_refresh_token": string;
	"driver_manager_users.telephony_refresh_token_exp": Date;
	"driver_manager_users.terminal_id": string;
	"driver_manager_users.time_format": string;
	"driver_manager_users.token_key": number;
	"driver_manager_users.toolbar_multi_rows": string;
	"driver_manager_users.toolbar_setting": string;
	"driver_manager_users.trailer_loan_profile_id": string;
	"driver_manager_users.trailer_wash_loc": string;
	"driver_manager_users.trailer_wash_user": string;
	"driver_manager_users.trimble_map_traffic": string;
	"driver_manager_users.tw_seg_code": string;
	"driver_manager_users.tw_ticket_template": number;
	"driver_manager_users.type_agents": string;
	"driver_manager_users.type_carrier": string;
	"driver_manager_users.type_company_drs": string;
	"driver_manager_users.type_number": string;
	"driver_manager_users.type_owner_oper": string;
	"driver_manager_users.user_group": string;
	"driver_manager_users.vendor_user_id": string;
	"driver_manager_users.view_movement_vendor": string;
	"driver_manager_users.waterfall_default_rt_guide": string;
	"driver_manager_users.waterfall_include_rates": string;
	"driver_manager_users.waterfall_include_rt_guides": string;
	"driver_manager_users.waterfall_prevent_tendering": string;
	"driver_manager_users.web_acct_status": string;
	"driver_manager_users.web_agent": string;
	"driver_manager_users.web_created_on": Date;
	"driver_manager_users.web_enabled_on": Date;
	"driver_manager_users.web_last_login": Date;
	"driver_manager_users.web_locked_on": Date;
	"driver_manager_users.web_map": string;
	"driver_manager_users.web_password": string;
	"driver_manager_users.web_user_id": string;
	"driver_manager_users.web_user_type": string;
	"driver_manager_users.window_location": string;
	"driver_manager_users.windows_login": string;
	"driver_manager_users.wire_trans_per_day": number;
	"driver_manager_users.zone_mapping_vendor": string;
	"equipment_driver.company_id": string;
	"equipment_driver.equipment_group_id": string;
	"equipment_driver.equipment_id": string;
	"equipment_driver.equipment_type_id": string;
	"equipment_driver.id": string;
	"equipment_driver.trailer_dropped": string;
	"equipment_driver.type_sequence": number;
	"equipment_tractor.company_id": string;
	"equipment_tractor.equipment_group_id": string;
	"equipment_tractor.equipment_id": string;
	"equipment_tractor.equipment_type_id": string;
	"equipment_tractor.id": string;
	"equipment_tractor.trailer_dropped": string;
	"equipment_tractor.type_sequence": number;
	"equipment_trailer.company_id": string;
	"equipment_trailer.equipment_group_id": string;
	"equipment_trailer.equipment_id": string;
	"equipment_trailer.equipment_type_id": string;
	"equipment_trailer.id": string;
	"equipment_trailer.trailer_dropped": string;
	"equipment_trailer.type_sequence": number;
	id: string;
	"movement.authorized": string;
	"movement.average_broker_rating": number;
	"movement.booking_no": string;
	"movement.br_details_link": string;
	"movement.br_status_link": string;
	"movement.br_track_interval": number;
	"movement.br_track_status": string;
	"movement.br_track_status_desc": string;
	"movement.br_track_vehicle_id": string;
	"movement.br_tracking_id": string;
	"movement.br_vendor": string;
	"movement.broker_avail_tract": string;
	"movement.brokerage": string;
	"movement.brokerage_status": string;
	"movement.buy_to_market_ex": string;
	"movement.carrier_contact": string;
	"movement.carrier_email": string;
	"movement.carrier_empty_from_city_id": number;
	"movement.carrier_fuel_pay_rate_id": number;
	"movement.carrier_lane_rate_id": string;
	"movement.carrier_override_carrier": string;
	"movement.carrier_override_user": string;
	"movement.carrier_phone": string;
	"movement.carrier_rate_id": number;
	"movement.carrier_tractor": string;
	"movement.carrier_trailer": string;
	"movement.carrier_trailer_type": string;
	"movement.chassis": string;
	"movement.checkcall_sched_id": string;
	"movement.company_id": string;
	"movement.container": string;
	"movement.container_returned": string;
	"movement.container_status": string;
	"movement.controlling_carrier_code": string;
	"movement.dedicated_order_id": string;
	"movement.dest_stop_id": string;
	"movement.digital_booking": string;
	"movement.dispatcher_user_id": string;
	"movement.eform_rate_confirmation": string;
	"movement.empty2next_order": string;
	"movement.equipment_group_id": string;
	"movement.est_tolls": number;
	"movement.est_tolls_c": string;
	"movement.est_tolls_d": Date;
	"movement.est_tolls_n": number;
	"movement.est_tolls_r": number;
	"movement.exclude_movement": string;
	"movement.fleet_manager": string;
	"movement.freight_matching_override": string;
	"movement.fuel_distance": number;
	"movement.fuel_distance_um": string;
	"movement.fuel_tax_exempt": string;
	"movement.hubtran_approved_inv_date": Date;
	"movement.hubtran_ok2pay_date": Date;
	"movement.ic_company_to": string;
	"movement.ic_order_to": string;
	"movement.id": string;
	"movement.integrated_carrier_search": string;
	"movement.invoice_recv_date": Date;
	"movement.is_container": string;
	"movement.is_dray": string;
	"movement.is_intercompany": string;
	"movement.is_local_mile": string;
	"movement.linked_id": number;
	"movement.linked_sequence": number;
	"movement.load_booking_eligible": string;
	"movement.load_booking_source": string;
	"movement.loaded": string;
	"movement.locked_user_id": string;
	"movement.ltl": string;
	"movement.ltl_staging_wrs_uid": number;
	"movement.macropoint_status": string;
	"movement.manifest_empty_distance": number;
	"movement.manifest_estimated_arrival": Date;
	"movement.manifest_estimated_depart": Date;
	"movement.manifest_id": string;
	"movement.manifest_loaded_distance": number;
	"movement.manifest_reg_uid": number;
	"movement.manifest_spots_capacity": number;
	"movement.manifest_spots_consumed": number;
	"movement.manifest_weight_capacity": number;
	"movement.manifest_weight_consumed": number;
	"movement.max_buy": number;
	"movement.max_buy_c": string;
	"movement.max_buy_d": Date;
	"movement.max_buy_n": number;
	"movement.max_buy_r": number;
	"movement.max_pay_method": string;
	"movement.max_pay_units": number;
	"movement.missed_call_sent": string;
	"movement.move_distance": number;
	"movement.move_distance_um": string;
	"movement.movement_type": string;
	"movement.must_respond_by": Date;
	"movement.next_sched_call": Date;
	"movement.operational_status": string;
	"movement.operations_user": string;
	"movement.origin_stop_id": string;
	"movement.override_crny_type": string;
	"movement.override_driver2_id": number;
	"movement.override_driver2_nm": string;
	"movement.override_driver_id": number;
	"movement.override_driver_nm": string;
	"movement.override_drvr2_cell": string;
	"movement.override_drvr2_email": string;
	"movement.override_drvr_cell": string;
	"movement.override_drvr_email": string;
	"movement.override_max_pay": number;
	"movement.override_max_pay_c": string;
	"movement.override_max_pay_d": Date;
	"movement.override_max_pay_n": number;
	"movement.override_max_pay_r": number;
	"movement.override_pay_amt": number;
	"movement.override_pay_amt_c": string;
	"movement.override_pay_amt_d": Date;
	"movement.override_pay_amt_n": number;
	"movement.override_pay_amt_r": number;
	"movement.override_pay_rate": number;
	"movement.override_paye_rate": number;
	"movement.override_payee_id": string;
	"movement.override_targetpay": number;
	"movement.override_targetpay_c": string;
	"movement.override_targetpay_d": Date;
	"movement.override_targetpay_n": number;
	"movement.override_targetpay_r": number;
	"movement.override_type": string;
	"movement.override_unit_desc": string;
	"movement.override_units": number;
	"movement.pay_distance": number;
	"movement.pay_distance_um": string;
	"movement.pending_carrier_name": string;
	"movement.pending_carrier_nbr": string;
	"movement.pending_carrier_type": string;
	"movement.pending_payee_id": string;
	"movement.placard_required": string;
	"movement.preassign_sequence": number;
	"movement.priority": string;
	"movement.pro_nbr": string;
	"movement.rate_alert_basis": string;
	"movement.rate_alert_date": Date;
	"movement.rate_alert_days": number;
	"movement.rate_alert_hours": number;
	"movement.rate_alert_minutes": number;
	"movement.rate_confirm_template": number;
	"movement.rate_confirmation_sent_date": Date;
	"movement.rate_confirmation_status": string;
	"movement.rate_expiration_basis": string;
	"movement.rate_expiration_date": Date;
	"movement.rate_expiration_days": number;
	"movement.rate_expiration_hours": number;
	"movement.rate_expiration_minutes": number;
	"movement.rdy_pickup_date": Date;
	"movement.recurring_movement_id": string;
	"movement.reminder_sent": string;
	"movement.require_tracking": string;
	"movement.required_vendor": string;
	"movement.reserved": string;
	"movement.return_date": Date;
	"movement.seg_alloc_code": string;
	"movement.shipper_email": string;
	"movement.shipper_notify_frequency": string;
	"movement.shpmt_ident_type": string;
	"movement.shpmt_ident_value": string;
	"movement.ss_location_id": string;
	"movement.status": string;
	"movement.target_extra_stop_pay": number;
	"movement.target_extra_stop_pay_c": string;
	"movement.target_extra_stop_pay_d": Date;
	"movement.target_extra_stop_pay_n": number;
	"movement.target_extra_stop_pay_r": number;
	"movement.target_fuel_surcharge_pay": string;
	"movement.target_pay": number;
	"movement.target_pay_c": string;
	"movement.target_pay_d": Date;
	"movement.target_pay_method": string;
	"movement.target_pay_n": number;
	"movement.target_pay_r": number;
	"movement.target_pay_units": number;
	"movement.target_rate_data": string;
	"movement.target_rate_id": number;
	"movement.time_to_send_msg": Date;
	"movement.track_start_date": Date;
	"movement.tracking_duration_ext": number;
	"movement.tracking_notify_email": string;
	"movement.tracking_request_status": string;
	"movement.trailer_rent_pct": number;
	"movement.trip_lease": string;
	"movement.trip_mgt_recalc_datetime": Date;
	"movement.trip_mgt_tracking_id": string;
	"movement.triumphpay_exclude": string;
	"movement.trp_uid": number;
	"movement.ts_borrowing_company": string;
	"movement.ts_commodity": string;
	"movement.ts_movement_id": string;
	"movement.unlock_time": Date;
	"movement.waterfall_flood_time": Date;
	"movement.waterfall_in_progress": string;
	"movement.xfer2settle_date": Date;
	"movement.xferred2fueltax": string;
	"movement.xferred2fueltaxdt": Date;
	"movement.xmit_accepted": string;
	"movement.xmitted2driver": Date;
	"movement.zmit_trip": string;
	movement_id: string;
	"movement_manager_users.acct_lock_date": Date;
	"movement_manager_users.active_date": Date;
	"movement_manager_users.admin_user": string;
	"movement_manager_users.agent": string;
	"movement_manager_users.agree_fieldmarshal": Date;
	"movement_manager_users.agree_tailor": Date;
	"movement_manager_users.agree_tailor_ext": Date;
	"movement_manager_users.all_contacts": string;
	"movement_manager_users.allow_new_devices": string;
	"movement_manager_users.alternative_user": string;
	"movement_manager_users.ap_division_id": string;
	"movement_manager_users.appt_sched_id": string;
	"movement_manager_users.auth_subject": string;
	"movement_manager_users.auto_edit_type": string;
	"movement_manager_users.avail_tract_path": string;
	"movement_manager_users.avail_tract_sample": string;
	"movement_manager_users.available": string;
	"movement_manager_users.bridge_customer_access": string;
	"movement_manager_users.brokerage_divider": number;
	"movement_manager_users.brokerage_planning": string;
	"movement_manager_users.brokerage_planning2": string;
	"movement_manager_users.brokerage_planning3": string;
	"movement_manager_users.brokerage_planning4": string;
	"movement_manager_users.brokerage_planning_contnr": string;
	"movement_manager_users.call_list_profile": string;
	"movement_manager_users.carrier_call_list_id": string;
	"movement_manager_users.carrier_mgr_profil": string;
	"movement_manager_users.carrier_mgr_profil2": string;
	"movement_manager_users.carrier_mgr_profil3": string;
	"movement_manager_users.carrier_mgr_profil4": string;
	"movement_manager_users.cell_phone": string;
	"movement_manager_users.close_window": string;
	"movement_manager_users.commission_payee_id": string;
	"movement_manager_users.company_id": string;
	"movement_manager_users.company_name": string;
	"movement_manager_users.conf_cntr_template": number;
	"movement_manager_users.conf_template": number;
	"movement_manager_users.confirm_record": string;
	"movement_manager_users.contact_id": string;
	"movement_manager_users.continuous_radius": number;
	"movement_manager_users.crm_vs_profile": string;
	"movement_manager_users.csm_profile_id": string;
	"movement_manager_users.csm_profile_id2": string;
	"movement_manager_users.csm_profile_id3": string;
	"movement_manager_users.csm_profile_id4": string;
	"movement_manager_users.currency_reporting": string;
	"movement_manager_users.currency_transaction": string;
	"movement_manager_users.daily_advance_limits": string;
	"movement_manager_users.daily_brok_profile": string;
	"movement_manager_users.daily_snap_profile": string;
	"movement_manager_users.date_format": string;
	"movement_manager_users.default_search": number;
	"movement_manager_users.default_wirecode": string;
	"movement_manager_users.delivered_load_day": number;
	"movement_manager_users.department_id": string;
	"movement_manager_users.detention_profile_id": string;
	"movement_manager_users.detention_profile_id2": string;
	"movement_manager_users.detention_profile_id3": string;
	"movement_manager_users.detention_profile_id4": string;
	"movement_manager_users.disp_new_order_screen": string;
	"movement_manager_users.distance_calc_vendor": string;
	"movement_manager_users.dock_enable_wfmd_mode_swtch": string;
	"movement_manager_users.dock_login_id": string;
	"movement_manager_users.dragndrop_profile_id": string;
	"movement_manager_users.driver_manager_profile": string;
	"movement_manager_users.driver_manager_profile2": string;
	"movement_manager_users.driver_manager_profile3": string;
	"movement_manager_users.driver_manager_profile4": string;
	"movement_manager_users.driver_manager_vendor": string;
	"movement_manager_users.driver_managers": string;
	"movement_manager_users.drivers_wo_manager": string;
	"movement_manager_users.ds_cap_profile": string;
	"movement_manager_users.ds_mv_eta_profile": string;
	"movement_manager_users.ds_mv_eval_profile": string;
	"movement_manager_users.dsp_override_user": string;
	"movement_manager_users.email_address": string;
	"movement_manager_users.email_bcc": string;
	"movement_manager_users.email_client": string;
	"movement_manager_users.email_host": string;
	"movement_manager_users.email_imap_host": string;
	"movement_manager_users.email_imap_password": string;
	"movement_manager_users.email_imap_sent_folder": string;
	"movement_manager_users.email_imap_ssl": string;
	"movement_manager_users.email_imap_username": string;
	"movement_manager_users.email_override_company": string;
	"movement_manager_users.email_password": string;
	"movement_manager_users.email_port": number;
	"movement_manager_users.email_protocol": string;
	"movement_manager_users.email_use_sent_folder": string;
	"movement_manager_users.email_username": string;
	"movement_manager_users.employee_type": string;
	"movement_manager_users.enable_alerts": string;
	"movement_manager_users.extension": string;
	"movement_manager_users.external_password": string;
	"movement_manager_users.external_user_id": string;
	"movement_manager_users.failed_logins": number;
	"movement_manager_users.fax": string;
	"movement_manager_users.fileimport_profile": string;
	"movement_manager_users.findnear_vendor": string;
	"movement_manager_users.fleetmgmt_prof_id": string;
	"movement_manager_users.fm_account_id": string;
	"movement_manager_users.fm_can_view_metadata": string;
	"movement_manager_users.fm_profile_id": string;
	"movement_manager_users.fm_webhook_url": string;
	"movement_manager_users.ftl_revenue_code_id": string;
	"movement_manager_users.google_map_layer": string;
	"movement_manager_users.google_map_type": string;
	"movement_manager_users.grid_even_row_color": number;
	"movement_manager_users.grid_insert_sort": string;
	"movement_manager_users.grid_odd_row_color": number;
	"movement_manager_users.id": string;
	"movement_manager_users.img_category": string;
	"movement_manager_users.inactive_date": Date;
	"movement_manager_users.is_active": string;
	"movement_manager_users.is_clearer": string;
	"movement_manager_users.is_closer": string;
	"movement_manager_users.is_dock_supervisor": string;
	"movement_manager_users.is_dock_worker": string;
	"movement_manager_users.is_email_confirmed": string;
	"movement_manager_users.is_mcleod": string;
	"movement_manager_users.issue_atm_cash": string;
	"movement_manager_users.lock_status": string;
	"movement_manager_users.log_sql": string;
	"movement_manager_users.login_id": string;
	"movement_manager_users.ltl_carrier_brk_status": string;
	"movement_manager_users.ltl_mapping_vendor": string;
	"movement_manager_users.ltl_quote_template": number;
	"movement_manager_users.manifest_profile": string;
	"movement_manager_users.margin_percentage": number;
	"movement_manager_users.max_payment_code_amt": number;
	"movement_manager_users.max_payment_code_amt_c": string;
	"movement_manager_users.max_payment_code_amt_d": Date;
	"movement_manager_users.max_payment_code_amt_n": number;
	"movement_manager_users.max_payment_code_amt_r": number;
	"movement_manager_users.mc_position_vendor": string;
	"movement_manager_users.menu_tree_view": string;
	"movement_manager_users.mfa_device_id": string;
	"movement_manager_users.mfa_last_prompted": Date;
	"movement_manager_users.mfa_secret": string;
	"movement_manager_users.mfa_status": string;
	"movement_manager_users.mobcomm_profile_id": string;
	"movement_manager_users.mobile_pw_reset_token": string;
	"movement_manager_users.mobile_pw_token_expire_ms": number;
	"movement_manager_users.move_dates": string;
	"movement_manager_users.movement_map_vendor": string;
	"movement_manager_users.name": string;
	"movement_manager_users.notification": string;
	"movement_manager_users.notify_alerts": string;
	"movement_manager_users.notify_frequency": string;
	"movement_manager_users.notify_method": string;
	"movement_manager_users.notify_occurance": string;
	"movement_manager_users.operations_user_id": string;
	"movement_manager_users.order_mode": string;
	"movement_manager_users.order_planning2": string;
	"movement_manager_users.order_planning3": string;
	"movement_manager_users.order_planning4": string;
	"movement_manager_users.order_planning_vendor": string;
	"movement_manager_users.order_tran_request": string;
	"movement_manager_users.orderhist_profile": string;
	"movement_manager_users.outbound_notification": string;
	"movement_manager_users.override_vendor_division": string;
	"movement_manager_users.payee_id": string;
	"movement_manager_users.pbw_brokerage_planning": string;
	"movement_manager_users.phone": string;
	"movement_manager_users.planner": string;
	"movement_manager_users.planning": string;
	"movement_manager_users.planning_container": string;
	"movement_manager_users.planning_divider": number;
	"movement_manager_users.portal_admin_id": string;
	"movement_manager_users.primary_agency": string;
	"movement_manager_users.prompt_cont_moves": string;
	"movement_manager_users.quote_comp_act_create": string;
	"movement_manager_users.quote_comp_act_id": string;
	"movement_manager_users.quote_pend_act_create": string;
	"movement_manager_users.quote_pend_act_id": string;
	"movement_manager_users.quote_template": number;
	"movement_manager_users.rapid_alert_expand": string;
	"movement_manager_users.rapid_alert_sound": string;
	"movement_manager_users.receive_alerts": string;
	"movement_manager_users.recruiting_profile": string;
	"movement_manager_users.request_location_vendor": string;
	"movement_manager_users.revenue_code_id": string;
	"movement_manager_users.route_detail_vendor": string;
	"movement_manager_users.save_screen_sizes": string;
	"movement_manager_users.search_history_limit": number;
	"movement_manager_users.sec_ans1": string;
	"movement_manager_users.sec_ans2": string;
	"movement_manager_users.sec_question1": number;
	"movement_manager_users.sec_question2": number;
	"movement_manager_users.seg_alloc_code": string;
	"movement_manager_users.sel_text_on_focus": string;
	"movement_manager_users.show_active": string;
	"movement_manager_users.show_google_route": string;
	"movement_manager_users.show_inactive": string;
	"movement_manager_users.single_point_vendor": string;
	"movement_manager_users.support_inactivate_date": Date;
	"movement_manager_users.system_tray": string;
	"movement_manager_users.table_even_row_color": string;
	"movement_manager_users.table_odd_row_color": string;
	"movement_manager_users.telephony_access_token": string;
	"movement_manager_users.telephony_access_token_exp": Date;
	"movement_manager_users.telephony_number": string;
	"movement_manager_users.telephony_password": string;
	"movement_manager_users.telephony_refresh_token": string;
	"movement_manager_users.telephony_refresh_token_exp": Date;
	"movement_manager_users.terminal_id": string;
	"movement_manager_users.time_format": string;
	"movement_manager_users.token_key": number;
	"movement_manager_users.toolbar_multi_rows": string;
	"movement_manager_users.toolbar_setting": string;
	"movement_manager_users.trailer_loan_profile_id": string;
	"movement_manager_users.trailer_wash_loc": string;
	"movement_manager_users.trailer_wash_user": string;
	"movement_manager_users.trimble_map_traffic": string;
	"movement_manager_users.tw_seg_code": string;
	"movement_manager_users.tw_ticket_template": number;
	"movement_manager_users.type_agents": string;
	"movement_manager_users.type_carrier": string;
	"movement_manager_users.type_company_drs": string;
	"movement_manager_users.type_number": string;
	"movement_manager_users.type_owner_oper": string;
	"movement_manager_users.user_group": string;
	"movement_manager_users.vendor_user_id": string;
	"movement_manager_users.view_movement_vendor": string;
	"movement_manager_users.waterfall_default_rt_guide": string;
	"movement_manager_users.waterfall_include_rates": string;
	"movement_manager_users.waterfall_include_rt_guides": string;
	"movement_manager_users.waterfall_prevent_tendering": string;
	"movement_manager_users.web_acct_status": string;
	"movement_manager_users.web_agent": string;
	"movement_manager_users.web_created_on": Date;
	"movement_manager_users.web_enabled_on": Date;
	"movement_manager_users.web_last_login": Date;
	"movement_manager_users.web_locked_on": Date;
	"movement_manager_users.web_map": string;
	"movement_manager_users.web_password": string;
	"movement_manager_users.web_user_id": string;
	"movement_manager_users.web_user_type": string;
	"movement_manager_users.window_location": string;
	"movement_manager_users.windows_login": string;
	"movement_manager_users.wire_trans_per_day": number;
	"movement_manager_users.zone_mapping_vendor": string;
	on_at_move_dest: string;
	on_at_move_origin: string;
	"operations_users.acct_lock_date": Date;
	"operations_users.active_date": Date;
	"operations_users.admin_user": string;
	"operations_users.agent": string;
	"operations_users.agree_fieldmarshal": Date;
	"operations_users.agree_tailor": Date;
	"operations_users.agree_tailor_ext": Date;
	"operations_users.all_contacts": string;
	"operations_users.allow_new_devices": string;
	"operations_users.alternative_user": string;
	"operations_users.ap_division_id": string;
	"operations_users.appt_sched_id": string;
	"operations_users.auth_subject": string;
	"operations_users.auto_edit_type": string;
	"operations_users.avail_tract_path": string;
	"operations_users.avail_tract_sample": string;
	"operations_users.available": string;
	"operations_users.bridge_customer_access": string;
	"operations_users.brokerage_divider": number;
	"operations_users.brokerage_planning": string;
	"operations_users.brokerage_planning2": string;
	"operations_users.brokerage_planning3": string;
	"operations_users.brokerage_planning4": string;
	"operations_users.brokerage_planning_contnr": string;
	"operations_users.call_list_profile": string;
	"operations_users.carrier_call_list_id": string;
	"operations_users.carrier_mgr_profil": string;
	"operations_users.carrier_mgr_profil2": string;
	"operations_users.carrier_mgr_profil3": string;
	"operations_users.carrier_mgr_profil4": string;
	"operations_users.cell_phone": string;
	"operations_users.close_window": string;
	"operations_users.commission_payee_id": string;
	"operations_users.company_id": string;
	"operations_users.company_name": string;
	"operations_users.conf_cntr_template": number;
	"operations_users.conf_template": number;
	"operations_users.confirm_record": string;
	"operations_users.contact_id": string;
	"operations_users.continuous_radius": number;
	"operations_users.crm_vs_profile": string;
	"operations_users.csm_profile_id": string;
	"operations_users.csm_profile_id2": string;
	"operations_users.csm_profile_id3": string;
	"operations_users.csm_profile_id4": string;
	"operations_users.currency_reporting": string;
	"operations_users.currency_transaction": string;
	"operations_users.daily_advance_limits": string;
	"operations_users.daily_brok_profile": string;
	"operations_users.daily_snap_profile": string;
	"operations_users.date_format": string;
	"operations_users.default_search": number;
	"operations_users.default_wirecode": string;
	"operations_users.delivered_load_day": number;
	"operations_users.department_id": string;
	"operations_users.detention_profile_id": string;
	"operations_users.detention_profile_id2": string;
	"operations_users.detention_profile_id3": string;
	"operations_users.detention_profile_id4": string;
	"operations_users.disp_new_order_screen": string;
	"operations_users.distance_calc_vendor": string;
	"operations_users.dock_enable_wfmd_mode_swtch": string;
	"operations_users.dock_login_id": string;
	"operations_users.dragndrop_profile_id": string;
	"operations_users.driver_manager_profile": string;
	"operations_users.driver_manager_profile2": string;
	"operations_users.driver_manager_profile3": string;
	"operations_users.driver_manager_profile4": string;
	"operations_users.driver_manager_vendor": string;
	"operations_users.driver_managers": string;
	"operations_users.drivers_wo_manager": string;
	"operations_users.ds_cap_profile": string;
	"operations_users.ds_mv_eta_profile": string;
	"operations_users.ds_mv_eval_profile": string;
	"operations_users.dsp_override_user": string;
	"operations_users.email_address": string;
	"operations_users.email_bcc": string;
	"operations_users.email_client": string;
	"operations_users.email_host": string;
	"operations_users.email_imap_host": string;
	"operations_users.email_imap_password": string;
	"operations_users.email_imap_sent_folder": string;
	"operations_users.email_imap_ssl": string;
	"operations_users.email_imap_username": string;
	"operations_users.email_override_company": string;
	"operations_users.email_password": string;
	"operations_users.email_port": number;
	"operations_users.email_protocol": string;
	"operations_users.email_use_sent_folder": string;
	"operations_users.email_username": string;
	"operations_users.employee_type": string;
	"operations_users.enable_alerts": string;
	"operations_users.extension": string;
	"operations_users.external_password": string;
	"operations_users.external_user_id": string;
	"operations_users.failed_logins": number;
	"operations_users.fax": string;
	"operations_users.fileimport_profile": string;
	"operations_users.findnear_vendor": string;
	"operations_users.fleetmgmt_prof_id": string;
	"operations_users.fm_account_id": string;
	"operations_users.fm_can_view_metadata": string;
	"operations_users.fm_profile_id": string;
	"operations_users.fm_webhook_url": string;
	"operations_users.ftl_revenue_code_id": string;
	"operations_users.google_map_layer": string;
	"operations_users.google_map_type": string;
	"operations_users.grid_even_row_color": number;
	"operations_users.grid_insert_sort": string;
	"operations_users.grid_odd_row_color": number;
	"operations_users.id": string;
	"operations_users.img_category": string;
	"operations_users.inactive_date": Date;
	"operations_users.is_active": string;
	"operations_users.is_clearer": string;
	"operations_users.is_closer": string;
	"operations_users.is_dock_supervisor": string;
	"operations_users.is_dock_worker": string;
	"operations_users.is_email_confirmed": string;
	"operations_users.is_mcleod": string;
	"operations_users.issue_atm_cash": string;
	"operations_users.lock_status": string;
	"operations_users.log_sql": string;
	"operations_users.login_id": string;
	"operations_users.ltl_carrier_brk_status": string;
	"operations_users.ltl_mapping_vendor": string;
	"operations_users.ltl_quote_template": number;
	"operations_users.manifest_profile": string;
	"operations_users.margin_percentage": number;
	"operations_users.max_payment_code_amt": number;
	"operations_users.max_payment_code_amt_c": string;
	"operations_users.max_payment_code_amt_d": Date;
	"operations_users.max_payment_code_amt_n": number;
	"operations_users.max_payment_code_amt_r": number;
	"operations_users.mc_position_vendor": string;
	"operations_users.menu_tree_view": string;
	"operations_users.mfa_device_id": string;
	"operations_users.mfa_last_prompted": Date;
	"operations_users.mfa_secret": string;
	"operations_users.mfa_status": string;
	"operations_users.mobcomm_profile_id": string;
	"operations_users.mobile_pw_reset_token": string;
	"operations_users.mobile_pw_token_expire_ms": number;
	"operations_users.move_dates": string;
	"operations_users.movement_map_vendor": string;
	"operations_users.name": string;
	"operations_users.notification": string;
	"operations_users.notify_alerts": string;
	"operations_users.notify_frequency": string;
	"operations_users.notify_method": string;
	"operations_users.notify_occurance": string;
	"operations_users.operations_user_id": string;
	"operations_users.order_mode": string;
	"operations_users.order_planning2": string;
	"operations_users.order_planning3": string;
	"operations_users.order_planning4": string;
	"operations_users.order_planning_vendor": string;
	"operations_users.order_tran_request": string;
	"operations_users.orderhist_profile": string;
	"operations_users.outbound_notification": string;
	"operations_users.override_vendor_division": string;
	"operations_users.payee_id": string;
	"operations_users.pbw_brokerage_planning": string;
	"operations_users.phone": string;
	"operations_users.planner": string;
	"operations_users.planning": string;
	"operations_users.planning_container": string;
	"operations_users.planning_divider": number;
	"operations_users.portal_admin_id": string;
	"operations_users.primary_agency": string;
	"operations_users.prompt_cont_moves": string;
	"operations_users.quote_comp_act_create": string;
	"operations_users.quote_comp_act_id": string;
	"operations_users.quote_pend_act_create": string;
	"operations_users.quote_pend_act_id": string;
	"operations_users.quote_template": number;
	"operations_users.rapid_alert_expand": string;
	"operations_users.rapid_alert_sound": string;
	"operations_users.receive_alerts": string;
	"operations_users.recruiting_profile": string;
	"operations_users.request_location_vendor": string;
	"operations_users.revenue_code_id": string;
	"operations_users.route_detail_vendor": string;
	"operations_users.save_screen_sizes": string;
	"operations_users.search_history_limit": number;
	"operations_users.sec_ans1": string;
	"operations_users.sec_ans2": string;
	"operations_users.sec_question1": number;
	"operations_users.sec_question2": number;
	"operations_users.seg_alloc_code": string;
	"operations_users.sel_text_on_focus": string;
	"operations_users.show_active": string;
	"operations_users.show_google_route": string;
	"operations_users.show_inactive": string;
	"operations_users.single_point_vendor": string;
	"operations_users.support_inactivate_date": Date;
	"operations_users.system_tray": string;
	"operations_users.table_even_row_color": string;
	"operations_users.table_odd_row_color": string;
	"operations_users.telephony_access_token": string;
	"operations_users.telephony_access_token_exp": Date;
	"operations_users.telephony_number": string;
	"operations_users.telephony_password": string;
	"operations_users.telephony_refresh_token": string;
	"operations_users.telephony_refresh_token_exp": Date;
	"operations_users.terminal_id": string;
	"operations_users.time_format": string;
	"operations_users.token_key": number;
	"operations_users.toolbar_multi_rows": string;
	"operations_users.toolbar_setting": string;
	"operations_users.trailer_loan_profile_id": string;
	"operations_users.trailer_wash_loc": string;
	"operations_users.trailer_wash_user": string;
	"operations_users.trimble_map_traffic": string;
	"operations_users.tw_seg_code": string;
	"operations_users.tw_ticket_template": number;
	"operations_users.type_agents": string;
	"operations_users.type_carrier": string;
	"operations_users.type_company_drs": string;
	"operations_users.type_number": string;
	"operations_users.type_owner_oper": string;
	"operations_users.user_group": string;
	"operations_users.vendor_user_id": string;
	"operations_users.view_movement_vendor": string;
	"operations_users.waterfall_default_rt_guide": string;
	"operations_users.waterfall_include_rates": string;
	"operations_users.waterfall_include_rt_guides": string;
	"operations_users.waterfall_prevent_tendering": string;
	"operations_users.web_acct_status": string;
	"operations_users.web_agent": string;
	"operations_users.web_created_on": Date;
	"operations_users.web_enabled_on": Date;
	"operations_users.web_last_login": Date;
	"operations_users.web_locked_on": Date;
	"operations_users.web_map": string;
	"operations_users.web_password": string;
	"operations_users.web_user_id": string;
	"operations_users.web_user_type": string;
	"operations_users.window_location": string;
	"operations_users.windows_login": string;
	"operations_users.wire_trans_per_day": number;
	"operations_users.zone_mapping_vendor": string;
	order_id: string;
	"origin.actual_arrival": Date;
	"origin.actual_departure": Date;
	"origin.address": string;
	"origin.address2": string;
	"origin.appointment_status_id": string;
	"origin.appt_contact_name": string;
	"origin.appt_required": string;
	"origin.cases": number;
	"origin.city_id": number;
	"origin.city_name": string;
	"origin.company_id": string;
	"origin.confirmed": string;
	"origin.contact_email": string;
	"origin.contact_name": string;
	"origin.dist_from_prev": number;
	"origin.dist_from_prev_um": string;
	"origin.driver_load_unload": string;
	"origin.edi_code": string;
	"origin.edi_loc_code": string;
	"origin.eta": Date;
	"origin.eta_distance": number;
	"origin.eta_late": string;
	"origin.eta_oor": string;
	"origin.google_place_id": string;
	"origin.grouped_id": number;
	"origin.hub": number;
	"origin.ic_stop_id": string;
	"origin.id": string;
	"origin.inbound_status": string;
	"origin.late_eta_colorcode": string;
	"origin.late_route_status": string;
	"origin.latitude": number;
	"origin.location_id": string;
	"origin.location_name": string;
	"origin.longitude": number;
	"origin.manifest_fgp_uid": number;
	"origin.manifest_reg_uid": number;
	"origin.move_dist_from_preassign": number;
	"origin.move_dist_from_preassign_um": string;
	"origin.move_dist_from_previous": number;
	"origin.move_dist_from_previous_um": string;
	"origin.movement_id": string;
	"origin.movement_sequence": number;
	"origin.operational_status": string;
	"origin.order_id": string;
	"origin.order_sequence": number;
	"origin.orig_sched_early": Date;
	"origin.orig_sched_late": Date;
	"origin.pallets_dropped": number;
	"origin.pallets_picked_up": number;
	"origin.payment_code_reviewed": string;
	"origin.phone": string;
	"origin.planned_arrival_time": Date;
	"origin.ponum": string;
	"origin.prior_uncleared_stops": string;
	"origin.projected_arrival": Date;
	"origin.pu_override_arrive_early": Date;
	"origin.pu_override_arrive_late": Date;
	"origin.rate_dist_from_previous": number;
	"origin.rate_dist_from_previous_um": string;
	"origin.refno": string;
	"origin.requested_service": string;
	"origin.sched_arrive_early": Date;
	"origin.sched_arrive_late": Date;
	"origin.seal": string;
	"origin.service_date": Date;
	"origin.showas_address": string;
	"origin.showas_address2": string;
	"origin.showas_city_id": number;
	"origin.showas_city_name": string;
	"origin.showas_location_id": string;
	"origin.showas_location_name": string;
	"origin.showas_state": string;
	"origin.showas_zip_code": string;
	"origin.signed_for_name": string;
	"origin.state": string;
	"origin.status": string;
	"origin.stop_type": string;
	"origin.trimble_place_id": string;
	"origin.txl_uid": number;
	"origin.volume": number;
	"origin.volume_um": string;
	"origin.weight": number;
	"origin.weight_um": string;
	"origin.zip_code": string;
	"origin.zone_id": string;
	"payee.ach_batch_class_code": string;
	"payee.add_fed_to_wh": number;
	"payee.add_fed_to_wh_c": string;
	"payee.add_fed_to_wh_d": Date;
	"payee.add_fed_to_wh_n": number;
	"payee.add_fed_to_wh_r": number;
	"payee.addl_st_to_whold": number;
	"payee.addl_st_to_whold_c": string;
	"payee.addl_st_to_whold_d": Date;
	"payee.addl_st_to_whold_n": number;
	"payee.addl_st_to_whold_r": number;
	"payee.address1": string;
	"payee.address2": string;
	"payee.adp_co_code": string;
	"payee.adp_e_no": string;
	"payee.birth_date": Date;
	"payee.check_address": string;
	"payee.check_address2": string;
	"payee.check_city": string;
	"payee.check_city_st_zip": string;
	"payee.check_date": Date;
	"payee.check_name": string;
	"payee.check_number": string;
	"payee.check_st": string;
	"payee.check_stub_comment": string;
	"payee.check_zip": string;
	"payee.city": string;
	"payee.city_amt_to_whold": number;
	"payee.city_amt_to_whold_c": string;
	"payee.city_amt_to_whold_d": Date;
	"payee.city_amt_to_whold_n": number;
	"payee.city_amt_to_whold_r": number;
	"payee.city_exemptions": number;
	"payee.city_tax_code": string;
	"payee.company_id": string;
	"payee.country_id": string;
	"payee.county_amt_to_whold": number;
	"payee.county_amt_to_whold_c": string;
	"payee.county_amt_to_whold_d": Date;
	"payee.county_amt_to_whold_n": number;
	"payee.county_amt_to_whold_r": number;
	"payee.county_exemptions": number;
	"payee.county_tax_code": string;
	"payee.currency": string;
	"payee.dependents": number;
	"payee.dependents_c": string;
	"payee.dependents_d": Date;
	"payee.dependents_n": number;
	"payee.dependents_r": number;
	"payee.disable_payroll_taxes": string;
	"payee.eft_first_name": string;
	"payee.eft_individual": string;
	"payee.eft_last_name": string;
	"payee.eft_middle_initial": string;
	"payee.email": string;
	"payee.email_summary": string;
	"payee.enable_carrier_app": string;
	"payee.exempt_from_fed": string;
	"payee.exempt_from_state": string;
	"payee.extra_withholdings": number;
	"payee.extra_withholdings_c": string;
	"payee.extra_withholdings_d": Date;
	"payee.extra_withholdings_n": number;
	"payee.extra_withholdings_r": number;
	"payee.fed_amt_to_whold": number;
	"payee.fed_amt_to_whold_c": string;
	"payee.fed_amt_to_whold_d": Date;
	"payee.fed_amt_to_whold_n": number;
	"payee.fed_amt_to_whold_r": number;
	"payee.fed_exemptions": number;
	"payee.fed_marital_status": string;
	"payee.freeze_pay": string;
	"payee.freight_matching_override": string;
	"payee.gp_exclude": string;
	"payee.gp_exported": Date;
	"payee.hire_date": Date;
	"payee.holiday_hours_pd": number;
	"payee.id": string;
	"payee.last_raise_date": Date;
	"payee.legal_name": string;
	"payee.load_booking_eligible": string;
	"payee.loadpay_contact_phone": string;
	"payee.multiple_jobs": string;
	"payee.name": string;
	"payee.non_office_emp": string;
	"payee.office_employee": string;
	"payee.other_deductions": number;
	"payee.other_deductions_c": string;
	"payee.other_deductions_d": Date;
	"payee.other_deductions_n": number;
	"payee.other_deductions_r": number;
	"payee.other_income": number;
	"payee.other_income_c": string;
	"payee.other_income_d": Date;
	"payee.other_income_n": number;
	"payee.other_income_r": number;
	"payee.overtime_hours_pd": number;
	"payee.payment_method": string;
	"payee.phone_number": string;
	"payee.posted_check_date": Date;
	"payee.prev_code": string;
	"payee.primary_agency": string;
	"payee.regular_hours_pd": number;
	"payee.remarks": string;
	"payee.settlement_status": string;
	"payee.sick_hours_pd": number;
	"payee.social_security_no": string;
	"payee.st_amt_to_whold": number;
	"payee.st_amt_to_whold_c": string;
	"payee.st_amt_to_whold_d": Date;
	"payee.st_amt_to_whold_n": number;
	"payee.st_amt_to_whold_r": number;
	"payee.st_marital_status": string;
	"payee.state": string;
	"payee.state_exemptions": number;
	"payee.state_tax_code": string;
	"payee.status": string;
	"payee.sui_tax_code": string;
	"payee.tax_table_city_aux": number;
	"payee.tax_table_city_misc": number;
	"payee.tax_table_county_aux": number;
	"payee.tax_table_county_misc": number;
	"payee.tax_table_fit_aux": number;
	"payee.tax_table_fit_misc": number;
	"payee.tax_table_st_aux": number;
	"payee.tax_table_st_misc": number;
	"payee.tax_table_sui_aux": number;
	"payee.tax_table_sui_misc": number;
	"payee.termination_date": Date;
	"payee.vacation_hours_pd": number;
	"payee.vm_part_update": string;
	"payee.w4_status": string;
	"payee.wf_queue": number;
	"payee.ytd_holiday_hrs": number;
	"payee.ytd_overtime_hrs": number;
	"payee.ytd_reg_hrs_paid": number;
	"payee.ytd_sick_hrs_paid": number;
	"payee.ytd_vacation_hrs": number;
	"payee.zip_code": string;
	planned_manifest_id: string;
	sequence: number;
}

